// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Entity;
(function (Entity) {
    Entity["ENTITY_UNKNOWN"] = "ENTITY_UNKNOWN";
    Entity["ENTITY_AGENT_CONFIG"] = "ENTITY_AGENT_CONFIG";
    Entity["ENTITY_AGENT_TRANSCRIPT"] = "ENTITY_AGENT_TRANSCRIPT";
    Entity["ENTITY_APPOINTMENT"] = "ENTITY_APPOINTMENT";
    Entity["ENTITY_CALL"] = "ENTITY_CALL";
    Entity["ENTITY_CALL_TRANSCRIPT"] = "ENTITY_CALL_TRANSCRIPT";
    Entity["ENTITY_CAMPAIGN"] = "ENTITY_CAMPAIGN";
    Entity["ENTITY_FAX"] = "ENTITY_FAX";
    Entity["ENTITY_FEATURE"] = "ENTITY_FEATURE";
    Entity["ENTITY_FORM_SUBMISSION"] = "ENTITY_FORM_SUBMISSION";
    Entity["ENTITY_KNOWLEDGE_BASE"] = "ENTITY_KNOWLEDGE_BASE";
    Entity["ENTITY_LOCATION"] = "ENTITY_LOCATION";
    Entity["ENTITY_ORGANIZATION"] = "ENTITY_ORGANIZATION";
    Entity["ENTITY_PAYMENTS"] = "ENTITY_PAYMENTS";
    Entity["ENTITY_PERSON"] = "ENTITY_PERSON";
    Entity["ENTITY_REVIEW"] = "ENTITY_REVIEW";
    Entity["ENTITY_SETTING"] = "ENTITY_SETTING";
    Entity["ENTITY_SMS"] = "ENTITY_SMS";
})(Entity || (Entity = {}));
export var Entity_index;
(function (Entity_index) {
    Entity_index[Entity_index["ENTITY_UNKNOWN"] = 0] = "ENTITY_UNKNOWN";
    Entity_index[Entity_index["ENTITY_AGENT_CONFIG"] = 17] = "ENTITY_AGENT_CONFIG";
    Entity_index[Entity_index["ENTITY_AGENT_TRANSCRIPT"] = 16] = "ENTITY_AGENT_TRANSCRIPT";
    Entity_index[Entity_index["ENTITY_APPOINTMENT"] = 1] = "ENTITY_APPOINTMENT";
    Entity_index[Entity_index["ENTITY_CALL"] = 13] = "ENTITY_CALL";
    Entity_index[Entity_index["ENTITY_CALL_TRANSCRIPT"] = 2] = "ENTITY_CALL_TRANSCRIPT";
    Entity_index[Entity_index["ENTITY_CAMPAIGN"] = 14] = "ENTITY_CAMPAIGN";
    Entity_index[Entity_index["ENTITY_FAX"] = 3] = "ENTITY_FAX";
    Entity_index[Entity_index["ENTITY_FEATURE"] = 12] = "ENTITY_FEATURE";
    Entity_index[Entity_index["ENTITY_FORM_SUBMISSION"] = 4] = "ENTITY_FORM_SUBMISSION";
    Entity_index[Entity_index["ENTITY_KNOWLEDGE_BASE"] = 15] = "ENTITY_KNOWLEDGE_BASE";
    Entity_index[Entity_index["ENTITY_LOCATION"] = 5] = "ENTITY_LOCATION";
    Entity_index[Entity_index["ENTITY_ORGANIZATION"] = 6] = "ENTITY_ORGANIZATION";
    Entity_index[Entity_index["ENTITY_PAYMENTS"] = 7] = "ENTITY_PAYMENTS";
    Entity_index[Entity_index["ENTITY_PERSON"] = 8] = "ENTITY_PERSON";
    Entity_index[Entity_index["ENTITY_REVIEW"] = 9] = "ENTITY_REVIEW";
    Entity_index[Entity_index["ENTITY_SETTING"] = 11] = "ENTITY_SETTING";
    Entity_index[Entity_index["ENTITY_SMS"] = 10] = "ENTITY_SMS";
})(Entity_index || (Entity_index = {}));
